/** Landing hero + search-card proportions · photo fills most of the first screen. */
export const homeHeroLayout = {
  plate:
    "relative w-full min-h-[70vh] overflow-hidden -mt-[4.5rem] pt-[4.5rem] sm:min-h-[78vh] sm:-mt-20 sm:pt-20",
  stage:
    "container relative z-10 flex min-h-[70vh] flex-col items-center justify-center px-5 pb-32 pt-16 text-center sm:min-h-[78vh] sm:pb-36 sm:pt-20",
  searchOverlap:
    "container relative z-20 -mt-32 flex justify-center px-4 pb-10 sm:-mt-36 sm:px-6 sm:pb-14 md:-mt-40 md:pb-16",
  searchWidth: "mx-auto w-[90%] max-w-7xl",
  searchCard:
    "rounded-2xl border border-black/5 bg-white p-7 shadow-[0_18px_50px_-12px_rgba(15,23,42,0.28)] sm:p-8 md:p-9 lg:p-10",
} as const;
